import { comparisonData } from '@/mocks/categories';

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium tracking-wide mb-3">
            Why It Matters
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950 mb-4">
            Traditional Shopping vs. <span className="text-primary-500">Spreadsheet Shopping</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            See how a <strong>hipobuy spreadsheet</strong> transforms your shopping experience from chaotic browsing to organized discovery.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-background-100">
                <th className="py-4 px-6 text-sm font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                <th className="py-4 px-6 text-sm font-semibold text-foreground-800 whitespace-nowrap">
                  <span className="flex items-center gap-2">
                    <i className="ri-shopping-cart-line text-base text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
                    Traditional Shopping
                  </span>
                </th>
                <th className="py-4 px-6 text-sm font-semibold text-foreground-800 whitespace-nowrap">
                  <span className="flex items-center gap-2">
                    <i className="ri-database-2-line text-base text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                    Spreadsheet Shopping
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr
                  key={row.feature}
                  className={`border-t border-background-200/50 ${
                    idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                  } hover:bg-accent-50/50 transition-colors`}
                >
                  <td className="py-3.5 px-6 text-sm font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                  <td className="py-3.5 px-6 text-sm text-foreground-500">{row.traditional}</td>
                  <td className="py-3.5 px-6 text-sm text-foreground-700 font-medium">
                    <span className="flex items-center gap-2">
                      <span className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-xs text-accent-600"></i>
                      </span>
                      {row.spreadsheet}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}